import { Table } from "react-bootstrap";
import "../../../common/styles/table.css"
const TableSkeleton = ({ rows = 5, columns = 5 }) => {
  return (
    <div className="custom-table-container mt-3">
      <div className="custom-table-wrapper">
        <Table hover className="custom-table">
          <thead className="custom-table-head">
            <tr>
              {Array.from({ length: columns }).map((_, index) => (
                <th key={index}>
                  <div
                    className="skeleton-box"
                    style={{
                      height: "20px",
                      width: "80%",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "4px",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  ></div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <tr key={rowIndex}>
                {Array.from({ length: columns }).map((_, colIndex) => (
                  <td key={colIndex}>
                    <div
                      className="skeleton-box"
                      style={{
                        height: "16px",
                        width: colIndex === columns - 1 ? "40%" : "90%",
                        backgroundColor: "#e0e0e0",
                        borderRadius: "4px",
                        animation: "pulse 1.5s ease-in-out infinite",
                        animationDelay: `${rowIndex * 0.1}s`,
                      }}
                    ></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <style jsx>{`
        @keyframes pulse {
          0%,
          100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

export default TableSkeleton;
